import { Component, Input, ChangeDetectionStrategy, ContentChild, TemplateRef } from '@angular/core'
import { SafeStyle, DomSanitizer } from '@angular/platform-browser'

@Component({
  selector: 'icos-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="icos-card {{parentClass}}">
      <div class="icos-card__header" *ngIf="header || headerStr">
        <ng-container *ngIf="header">
          <ng-template [ngTemplateOutlet]="header">
          </ng-template>
        </ng-container>
        <ng-container *ngIf="!header">
          {{headerStr}}
        </ng-container>
      </div>
      <div class="icos-card__body" [style]="makeSafebodyStyle()">
        <ng-content></ng-content>
      </div>
    </div>
  `,
})
export class IcosCard {

  @ContentChild('header') header: TemplateRef<any>
  @Input('header') headerStr: string
  @Input('class') parentClass: string
  @Input('body-style') bodyStyle: string = ''

  constructor(
    private sanitizer: DomSanitizer,
  ) {
  }

  makeSafebodyStyle(): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(this.bodyStyle)
  }

}
